export default {
    token: '',
    email: "",
    name: "",
    tenant: "",
    loginData: {},
    hasLogged: false,
    permissionRoutes: [],
    originBackoffice: false
}